export default (activeSelector) => {
  activeSelector = activeSelector.toLowerCase();

  return [
    {
      title: 'Bedrijfsfilm',
      type: 'video',
      active: (activeSelector === 'bedrijfsfilm'),
    },
    {
      title: 'Commercial',
      type: 'commercial',
      active: (activeSelector === 'commercial'),
    },
    {
      title: 'Telefonie / IVR',
      type: 'ivr',
      active: (activeSelector === 'telefonie / ivr'),
    },
    {
      title: 'Explainer',
      type: 'video',
      active: (activeSelector === 'explainer'),
    },
    {
      title: 'Audioboek',
      type: 'audiobook',
      active: (activeSelector === 'audiobook'),
    },
    {
      title: 'Documentaire',
      type: 'video',
      active: (activeSelector === 'documentaire'),
    },
    {
      title: 'TV-Programma',
      type: 'video',
      active: (activeSelector === 'tv-programma'),
    },
    {
      title: 'Anders, n.t.b.',
      type: 'other',
      active: (activeSelector === 'anders, n.t.b.'),
    },
  ];
};
